import { useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";

import { fetchMovies, searchMovie } from "../stores/actions/movieAction";
import Swal from "sweetalert2";
import logo from "../assets/logo.png";

function NavBar() {
  const [searchInput, setsearchInput] = useState({
    search: "",
  });
  const dispatch = useDispatch();
  let nonActiveClassName =
    "cursor-pointer rounded-lg px-3 py-2 text-biru text-lg font-semibold hover:bg-white hover:text-biru";
  let activeClassName =
    "cursor-pointer rounded-lg px-3 py-2 text-biru text-lg font-semibold bg-white text-biru";

  const changeInput = (e) => {
    const { name, value } = e.target;
    setsearchInput({ ...searchInput, [name]: value });
  };

  const searchHandler = () => {
    dispatch(searchMovie(searchInput))
      .then(() => {
        showLoading();
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.message,
        });
      });
  };
  function showLoading() {
    Swal.fire({
      title: "Loading",
      timer: 1200,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }
  const backToHome = () => {
    dispatch(fetchMovies()).then(() => {
      showLoading();
      setsearchInput({
        search: "",
      });
    });
  };
  return (
    <nav className="fixed px-3 flex justify-between items-center w-full top-0 z-50 bg-kuning h-12">
      <div className="flex">
        <img
          src={logo}
          className="mr-1 h-8 my-auto"
          alt="Rotten Berries Logo"
        />
        <span className="mr-2 self-center text-biru text-xl font-semibold whitespace-nowrap dark:text-white">
          Rotten Berries
        </span>
        <NavLink
          className={({ isActive }) =>
            isActive ? activeClassName : nonActiveClassName
          }
          to="/"
          onClick={backToHome}
        >
          Home
        </NavLink>
      </div>
      <div>
        <div className="flex justify-center">
          <div className="mt-4">
            <div className="input-group relativeflex flex-wrap items-stretch w-full mb-4">
              <input
                type="search"
                className="form-control relative  h-8  flex-auto min-w-0 block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                placeholder="Search movie review"
                name="search"
                aria-label="Search movie review"
                aria-describedby="button-addon2"
                onChange={changeInput}
                value={searchInput.search}
              />
            </div>
          </div>
          <button
            className="btn inline-block mt-4 mb-4 ml-2 px-6 py-3 my-auto h-8 bg-biru text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-biru-gelap hover:shadow-lg focus:bg-biru-gelap focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out flex items-center"
            type="button"
            id="button-addon2"
            onClick={searchHandler}
          >
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="search"
              className="w-4"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
